import {base} from '../../../models/base';
import { fromJS } from "immutable";

export default {
  namespace: 'school',
  state: {},
  reducers: Object.assign(
    base,
    {
      setCounselling(state, {items, meta}){
        console.info("school/csItems", items);
        return { ...state, csItems: fromJS(items), csMeta: meta, csOrig: fromJS(items) };
      },
      selectedItem(state, {item}){
        return { ...state, selectedItem: item };
      },
      /**
       * Filter by status
       * @param state
       * @param value
       * @returns {{csItems: any, filterStatus: *}}
       */
      filterStatus(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('status') === value);
        return { ...state, csItems: csItems, filterStatus: value };
      },
      filterVisa(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('acquired_visa') === value);
        return { ...state, csItems: csItems, filterVisa: value };
      },
      filterSchoolType(state, {value}){
        const csItems = (value === 'all')?state.csOrig:state.csOrig.filter(x => x.get('school_type') === value);
        return { ...state, csItems: csItems, filterVisa: value };
      }
    }
  ),
};



// WEBPACK FOOTER //
// ./src/pages/school/models/school.js